import React, { useEffect } from "react";
import "./Projects.css";

const Projects = (props) => {
  useEffect(() => {
    document.title = "My Projects";
  }, []);

  let mycolor = "#E1B48F";

  if (props.color !== mycolor) props.backColor(mycolor);

  return (
    <div>
      <h1
        className="ui header red"
        style={{
          margin: "20px 0px",
          fontSize: "30px",
          fontFamily: "Roboto Slab",
        }}
      >
        Projects🚧⌨️
      </h1>
      <p style={{ color: "black", fontFamily: "sans-serif", color: "brown" }}>
        *Click🖱️🖱️ on the image for github link or deployed website!!
      </p>
      <div>
        <div class="accordion">
          <ul>
            <li>
              <div>
                <a
                  href="https://github.com/saksham1998/React-Videos"
                  target="_blank"
                >
                  <h2>React Videos</h2>

                  <p>
                    Simple Youtube Clone build on top of React JS,
                    <br /> using Youtube API.
                  </p>
                  <p>
                    <mark>Tech Stack</mark>: React JS,Javascript
                  </p>
                </a>
              </div>
            </li>
            <li>
              <div>
                <a
                  href="https://github.com/saksham1998/Blogger-Backend"
                  target="_blank"
                >
                  <h2>Blogger Backend</h2>
                  <p>
                    Backend for blog service. With User Registration, Login,
                    <br /> Profile Update, Blog Creation, Likes, Comments and
                    much more!!!!
                  </p>
                  <p>
                    <mark>Tech Stack</mark>: Node JS,Express,Mongoose,Javascript
                  </p>
                </a>
              </div>
            </li>
            <li>
              <div>
                <a
                  href="https://github.com/saksham1998/ML-DL-Projects"
                  target="_blank"
                >
                  <h2>ML/DL Directory</h2>
                  <p>
                    Machine Learning/Deep Learning Directory
                    <br />
                    with various projects ranging from Churn Prediction,Diabetes
                    Classifier
                    <br /> and much more!!!
                  </p>
                  <p>
                    <mark>Tech Stack</mark>: Python,Numpy Stack,Keras,Scikit
                    Learn etc
                  </p>
                </a>
              </div>
            </li>
            <li>
              <div>
                <a href="https://fluke.herokuapp.com/" target="_blank">
                  <h2>Fluke</h2>
                  <p>
                    Fluke is real time chat app, which uses Socket IO and
                    multiple
                    <br /> libraries for the communication between server and
                    client.
                    <br />
                    With the help of socket io, Fluke stores the users on server
                    and show them when needed.
                  </p>
                  <p>
                    <mark>Tech Stack</mark>: Node JS,Socket
                    IO,Javascript,Mongoose
                  </p>
                </a>
              </div>
            </li>
            <li>
              <div>
                <a href="https://bamboozled.netlify.com/" target="_blank">
                  <h2>Bamboozled</h2>
                  <p>
                    A simple quiz game ,with different categories to choose
                    from.Uses Api to fetch <br />
                    game details and shows them in timely fashion
                    <br />
                    Other Features Include Score Storage,Timer etc
                  </p>
                  <p>
                    <mark>Tech Stack</mark>: Javascript,REST API,HTML,CSS
                  </p>
                </a>
              </div>
            </li>
            <li tabindex="6">
              <div>
                <a href="https://whattheweather.netlify.com/" target="_blank">
                  <h2>What the Weather</h2>
                  <p>
                    Weather App built on top of Javascript.Takes location <br />
                    information and outputs various weather details like <br />
                    Temperature,Humidity,Wind Speed,UV-Index,Summary etc
                  </p>
                  <p>
                    <mark>Tech Stack</mark>: Javascript,Node JS,REST
                    API,HTML,CSS
                  </p>
                </a>
              </div>
            </li>
          </ul>
        </div>
        <br />
        {/* <p class="ui link" style={{ color: "brown" }}>
          Credits to{" "}
          <a href="https://codepen.io/ferry" target="_blank">
            Micheal Ferry📷
          </a>{" "}
          for Design.
        </p> */}
      </div>
    </div>
  );
};

export default Projects;
